import { CHAPTERS } from "./data";
import { Reveal, Eyebrow } from "./Reveal";

export default function Manifesto() {
  return (
    <section className="relative py-28 md:py-40" data-testid="manifesto-section">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <Reveal className="mb-16 md:mb-24">
          <Eyebrow className="mb-4">Why Nuun</Eyebrow>
          <h2 className="font-display font-semibold text-4xl md:text-6xl leading-tight max-w-3xl">
            Three things we never compromise.
          </h2>
        </Reveal>

        <div>
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.08}>
              <div
                data-testid={`manifesto-chapter-${c.n}`}
                className="group grid md:grid-cols-[110px_1fr_1.2fr] gap-4 md:gap-10 items-baseline border-t border-white/10 py-12 md:py-16 transition-colors duration-500 hover:bg-white/[0.02] px-2 md:px-4"
              >
                <span className="font-mono font-thin text-5xl md:text-7xl text-white/10 group-hover:text-ember transition-colors duration-500">
                  {c.n}
                </span>
                <h3 className="font-display font-semibold text-3xl md:text-5xl leading-tight">
                  {c.title}
                </h3>
                <p className="text-dim leading-relaxed max-w-xl text-base md:text-lg">
                  {c.text}
                </p>
              </div>
            </Reveal>
          ))}
          <div className="border-t border-white/10" />
        </div>
      </div>
    </section>
  );
}
